/* VitaFresh Startseite (Mockup v3, Pasci 10.10.2026): kleine Ergänzungen, die Seite funktioniert auch ohne dieses Skript.
   1. Bewertungen (sections/vf-startseite-bewertungen.liquid): Punkte unter dem Karussell, «Ganze Bewertung lesen» nur bei
      gekürzten Texten, ganzer Text im <dialog>. Die Pfeile macht assets/vfp-karussell.js.
   2. Fragen (sections/vf-startseite-fragen.liquid): Einleitung mittig neben den EINGEKLAPPTEN Fragen; der Versatz bleibt beim
      Aufklappen gleich, damit nichts springt.
   Jede Section wird genau einmal eingerichtet (data-…="bereit"). Reine Logik in Node testbar: node --test tests/vfp-start.test.js */
(function (root) {
  "use strict";

  var TOLERANZ_PX = 2; /* Subpixel-Rundung: so viel höher gilt noch nicht als «gekürzt» */

  /* Wird der Text vom CSS (line-clamp) abgeschnitten? */
  function istGekuerzt(scrollHoehe, sichtHoehe) {
    return scrollHoehe > sichtHoehe + TOLERANZ_PX;
  }

  /* Welche Karten sind sichtbar? Index der ersten und Anzahl, begrenzt auf die Kartenzahl. */
  function sichtbareKarten(scrollLinks, schritt, sichtBreite, anzahl) {
    if (!(schritt > 0) || !(anzahl > 0)) return { von: 0, zahl: Math.max(0, anzahl) };
    var zahl = Math.max(1, Math.min(anzahl, Math.round(sichtBreite / schritt)));
    var von = Math.min(Math.max(0, Math.round(scrollLinks / schritt)), anzahl - zahl);
    return { von: von, zahl: zahl };
  }

  /* Versatz der Einleitung: halbe Differenz zur Höhe der eingeklappten Fragen, nie negativ. */
  function versatz(fragenHoehe, introHoehe) {
    if (!(fragenHoehe > 0) || !(introHoehe >= 0)) return 0;
    return Math.max(0, Math.round((fragenHoehe - introHoehe) / 2));
  }

  /* «Vorname · Monat Jahr»: Name und Datum stehen im Markup getrennt (Text und <small>). */
  function wer(vorname, datum) {
    var n = String(vorname || "").replace(/\s+/g, " ").trim();
    var d = String(datum || "").replace(/\s+/g, " ").trim();
    return n && d ? n + " · " + d : n || d;
  }
  function werZeile(el) {
    var datum = el.querySelector("small");
    var vorname = "";
    for (var i = 0; i < el.childNodes.length; i++) if (el.childNodes[i].nodeType === 3) vorname += el.childNodes[i].nodeValue;
    return wer(vorname, datum ? datum.textContent : "");
  }

  /* ---------- Bewertungen ---------- */
  function bewertungenEinrichten(sec) {
    if (sec.getAttribute("data-vfp-start-bew") === "bereit") return;
    var spur = sec.querySelector(".vfp-karussell__spur");
    var punkte = sec.querySelector("[data-vfp-start-punkte]");
    var dialog = sec.querySelector("dialog");
    if (!spur) return;
    sec.setAttribute("data-vfp-start-bew", "bereit");
    var karten = [].slice.call(spur.querySelectorAll(".vfp-karussell__karte"));
    var knoepfe = [];

    function schritt() {
      return karten.length > 1 ? karten[1].offsetLeft - karten[0].offsetLeft : spur.clientWidth;
    }
    function zeige(i) {
      if (!karten[i]) return;
      spur.scrollTo({ left: karten[i].offsetLeft - karten[0].offsetLeft });
    }

    if (punkte && karten.length > 1) {
      var vorlage = punkte.getAttribute("data-label") || "[nr]";
      karten.forEach(function (k, i) {
        var b = root.document.createElement("button");
        b.type = "button";
        b.className = "vfp-start-bew__punkt";
        b.setAttribute("aria-label", vorlage.replace("[nr]", String(i + 1)));
        b.setAttribute("aria-controls", spur.id);
        b.addEventListener("click", function () { zeige(i); });
        punkte.appendChild(b);
        knoepfe.push(b);
      });
    }

    var geplant = false;
    function auffrischen() {
      geplant = false;
      var s = sichtbareKarten(spur.scrollLeft, schritt(), spur.clientWidth, karten.length);
      knoepfe.forEach(function (b, j) { b.setAttribute("aria-current", String(j >= s.von && j < s.von + s.zahl)); });
      karten.forEach(function (k) {
        var p = k.querySelector(".vfp-start-bew__text");
        var ganz = k.querySelector(".vfp-start-bew__ganz");
        if (p && ganz) ganz.hidden = !istGekuerzt(p.scrollHeight, p.clientHeight);
      });
    }
    function planen() {
      if (geplant) return;
      geplant = true;
      root.requestAnimationFrame(auffrischen);
    }
    spur.addEventListener("scroll", planen, { passive: true });
    if (root.ResizeObserver) new root.ResizeObserver(planen).observe(spur);
    if (root.document.fonts && root.document.fonts.ready) root.document.fonts.ready.then(planen);
    auffrischen();

    if (!dialog || typeof dialog.showModal !== "function") return;
    function feld(name) { return dialog.querySelector('[data-feld="' + name + '"]'); }
    spur.addEventListener("click", function (e) {
      var ganz = e.target.closest(".vfp-start-bew__ganz");
      if (!ganz) return;
      var karte = ganz.closest(".vfp-start-bew__karte");
      var sterne = karte.querySelector(".vfp-start-sterne");
      var titel = karte.querySelector(".vfp-start-bew__titel");
      var name = karte.querySelector(".vfp-start-bew__name");
      /* Nur textContent und eine CSS-Variable: kein HTML aus den Einträgen. */
      var s = feld("sterne");
      s.hidden = !sterne;
      if (sterne) {
        s.style.setProperty("--vfp-start-wert", sterne.style.getPropertyValue("--vfp-start-wert"));
        s.setAttribute("aria-label", sterne.getAttribute("aria-label") || "");
      }
      feld("titel").textContent = titel ? titel.textContent : "";
      feld("text").textContent = karte.querySelector(".vfp-start-bew__text").textContent;
      feld("wer").textContent = name ? werZeile(name) : "";
      dialog.showModal();
    });
    dialog.querySelector(".vfp-start-bew__zu").addEventListener("click", function () { dialog.close(); });
    dialog.addEventListener("click", function (e) { if (e.target === dialog) dialog.close(); });
  }

  /* ---------- Fragen ---------- */
  function fragenEinrichten(sec) {
    if (sec.getAttribute("data-vfp-start-fragen") === "bereit") return;
    var raster = sec.querySelector(".vfp-start-fragen__raster");
    var intro = sec.querySelector(".vfp-start-fragen__intro");
    var liste = sec.querySelector(".vfp-start-fragen__liste");
    if (!raster || !intro || !liste) return;
    sec.setAttribute("data-vfp-start-fragen", "bereit");

    /* Höhe der Liste, als wären alle Fragen zu: je <details> nur Frage-Zeile und Rahmen. */
    function hoeheZu() {
      var kinder = liste.children, summe = 0;
      for (var i = 0; i < kinder.length; i++) {
        var k = kinder[i];
        if (k.tagName === "DETAILS") {
          var frage = k.querySelector("summary");
          summe += (frage ? frage.offsetHeight : 0) + (k.offsetHeight - k.clientHeight);
        } else {
          summe += k.offsetHeight;
        }
      }
      var abstand = parseFloat(root.getComputedStyle(liste).rowGap) || 0;
      return summe + abstand * Math.max(0, kinder.length - 1);
    }
    function setzen() {
      var spalten = root.getComputedStyle(raster).gridTemplateColumns.split(" ").length;
      if (spalten < 2) { intro.style.removeProperty("--vfp-start-versatz"); return; }
      intro.style.setProperty("--vfp-start-versatz", versatz(hoeheZu(), intro.offsetHeight) + "px");
    }
    var geplant = false;
    function planen() {
      if (geplant) return;
      geplant = true;
      root.requestAnimationFrame(function () { geplant = false; setzen(); });
    }
    if (root.ResizeObserver) new root.ResizeObserver(planen).observe(raster);
    if (root.document.fonts && root.document.fonts.ready) root.document.fonts.ready.then(planen);
    setzen();
  }

  function start() {
    var b = root.document.querySelectorAll("[data-vfp-start-bew]");
    for (var i = 0; i < b.length; i++) bewertungenEinrichten(b[i]);
    var f = root.document.querySelectorAll("[data-vfp-start-fragen]");
    for (var j = 0; j < f.length; j++) fragenEinrichten(f[j]);
  }

  if (typeof module !== "undefined" && module.exports) {
    module.exports = { wer: wer, istGekuerzt: istGekuerzt, sichtbareKarten: sichtbareKarten, versatz: versatz };
  } else if (root.document && !root.vfpStartGeladen) {
    /* Mehrfach eingebunden (je Section ein <script>)? Nur der erste Lauf registriert die Listener. */
    root.vfpStartGeladen = true;
    if (root.document.readyState === "loading") root.document.addEventListener("DOMContentLoaded", start); else start();
    root.document.addEventListener("shopify:section:load", start);
  }
})(typeof window !== "undefined" ? window : globalThis);
